import { useSelector } from 'react-redux';
import classes from './Tabs.module.scss';

const Tabs = ({ tabs, onTabClick, activeTabId }) => {

    const { texts } = useSelector(state => state.translate);

    return (
            <div className={classes.Menu} >
                {tabs.map(tab => (
                    <div
                        className={`${classes.NavItem} ${activeTabId === tab?.id ? classes.ActiveNavItem : ''}`}
                        key={tab.id}
                        onClick={() => onTabClick(tab.id)}
                    >
                        <p className={classes.Text}>{texts[tab?.title]}</p>
                    </div>
                ))}
            </div>
    );
}
export default Tabs